import script from "./FormatButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./FormatButtons.vue?vue&type=script&setup=true&lang=js"

import "./FormatButtons.vue?vue&type=style&index=0&id=a0b589a6&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0b589a6"]])

export default __exports__